import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ModalBody, ModalHeader, Button } from 'reactstrap'

import Checkbox from 'common-components/checkbox'
import { getIcon } from 'e-submission/components/Icon'
import { Modal } from 'common-components/index'
import { removeError, setAppValue, setResendEkycLink } from '../../../apps/actions'
import { getCurrentApp } from 'e-submission/apps/selectors'
import _getOr from 'lodash/fp/getOr'
import { isOnDeviceEKYC } from 'e-submission/domain/data-model/form/selectors'
import { IsRealDevice, isDisable2ndDoc as shouldDisable2ndDoc } from 'e-submission/utils'
import { isSelectedRemoteSelling } from '../../../domain/data-model/form/selectors'

const shouldDisabledSubmitButton = (isFailedState, isSkipEkyc) => {
  if (isSkipEkyc) return false
  return isFailedState
}

const resource = {
  reuseSuccess: {
    icon: getIcon('ekycStatusSuccess'),
    titleText: function() {
      return 'ผลการยืนยัน eKYC สำเร็จ'
    },
    detailText: function() {
      return 'กรุณากดปุ่ม ยืนยัน เพื่อเข้าสู่ขั้นตอนถัดไป'
    },
  },
  success: {
    icon: getIcon('ekycStatusSuccess'),
    titleText: function() {
      return 'สร้างลิงก์สำเร็จ'
    },
    detailText: function() {
      return 'ระบบได้ทำการสร้างลิงก์ \n\t เพื่อส่งขั้นตอนยืนยันตัวตนให้กับ<br class="d-md-none d-block">ผู้เอาประกันหรือผู้ชำระเบี้ยสำเร็จ'
    },
  },
  failed: {
    icon: getIcon('ekycStatusError'),
    titleText: function(isOnDeviceEkyc, isDisable2ndDoc, isRemoteSellingRespond) {
      const text = isOnDeviceEkyc && IsRealDevice ? 'สร้างเคสไม่สำเร็จ' : 'สร้างลิงก์ไม่สำเร็จ'
      if (isRemoteSellingRespond) {
        return text
      }
      if (isDisable2ndDoc) {
        return 'ขณะนี้ระบบไม่สามารถดำเนินการยืนยันตัวตนได้'
      }

      return text
    },
    detailText: function(isOnDeviceEkyc, isDisable2ndDoc, isRemoteSellingRespond) {
      const text =
        isOnDeviceEkyc && IsRealDevice
          ? 'ระบบไม่สามารถทำการสร้างเคสนี้ได้ \n\t ท่านสามารถปิดหน้าต่างนี้เพื่อทำการยืนยันตัวตนอีกครั้ง'
          : 'ระบบไม่สามารถทำการสร้างลิงก์ของเคสนี้ได้ \n\t ท่านสามารถปิดหน้าต่างนี้เพื่อทำการส่งลิงก์ในการยืนยันตัวตนอีกครั้ง'
      if (isRemoteSellingRespond) {
        return text
      }
      if (isDisable2ndDoc) {
        return 'ท่านสามารถปิดหน้าต่างนี้เพื่อทำการยืนยันตัวตนอีกครั้ง'
      }

      return text
    },
  },
  failedReuse: {
    icon: getIcon('ekycStatusError'),
    titleText: function(isOnDeviceEkyc) {
      const text = isOnDeviceEkyc && IsRealDevice ? 'สร้างเคสไม่สำเร็จ' : 'สร้างลิงก์ไม่สำเร็จ'

      return text
    },
    detailText: function(isOnDeviceEkyc) {
      const text =
        isOnDeviceEkyc && IsRealDevice
          ? 'ระบบไม่สามารถทำการสร้างเคสนี้ได้ \n\t ท่านสามารถปิดหน้าต่างนี้เพื่อทำการยืนยันตัวตนอีกครั้ง'
          : 'ระบบไม่สามารถทำการสร้างลิงก์ของเคสนี้ได้ \n\t ท่านสามารถปิดหน้าต่างนี้เพื่อทำการส่งลิงก์ในการยืนยันตัวตนอีกครั้ง'

      return text
    },
  },
  warning: {
    icon: getIcon('ekycStatusWarning'),
    titleText: function() {
      return 'ระบบขัดข้อง'
    },
    detailText: function() {
      // eslint-disable-next-line quotes
      return `กรุณากดยืนยันเพื่อกลับไปยังหน้าแรกเพื่อทำการส่งลิงก์อีกครั้ง \n\t หรือ ทำการปิดหน้าต่างนี้และเลือกคำสั่งใหม่อีกครั้ง`
    },
  },
}

const SubmitButton = (props) => {
  const { onExit, isInvalid, isSkipEkyc, setSkippedEkyc, onSubmit = () => {}, isRemoteSellingRespond } = props
  const isDisabled = shouldDisabledSubmitButton(isInvalid, isSkipEkyc)
  return (
    <div className={'normal-text detail-text button-submit'}>
      <Button
        color={isDisabled ? 'disabled' : 'primary'}
        className="primary"
        onClick={() => {
          onExit()
          if (isInvalid && !isRemoteSellingRespond) setSkippedEkyc()
          onSubmit()
        }}
        disabled={isDisabled}
      >
        ยืนยัน
      </Button>
    </div>
  )
}

const AdditionalForFailedCase = (props) => {
  const { toggleSkippingEKYC, isSkipEkyc, isDisable2ndDoc, identifyEkycRespond } = props
  return (
    <div className={'additional-failed-container'}>
      <span className={'text-header'}>ยืนยันตัวตนด้วยวิธีการอัปโหลดเอกสารแทน</span>
      <div className={'form-group'}>
        <Checkbox
          checked={isSkipEkyc}
          onChange={() => {
            toggleSkippingEKYC()
          }}
        >
          เลือกเพื่อทำขั้นตอนการอัปโหลดเอกสารแทน โดยแนบบัตรประชาชน
          {(!isDisable2ndDoc || identifyEkycRespond === 'failedReuse') && ' และทะเบียนบ้าน'}
        </Checkbox>
      </div>
      <span className={'remark-text'}>
        {identifyEkycRespond === 'failedReuse'
          ? `*หมายเหตุท่านจะต้องทำการยืนยันตัวตนอิเล็กทรอนิกส์ (eKYC) อีกครั้ง หลังจากส่งใบคำขอเข้าระบบ AdvisorZone`
          : isDisable2ndDoc
          ? `กรุณาดำเนินการยืนยันตัวตนผ่าน eKYC Service หลังจากที่กดนำส่งงานเรียบร้อยแล้ว มิเช่นนั้นบริษัทจะไม่สามารถดำเนินการพิจารณาอนุมัติกรมธรรมได้`
          : `*หมายเหตุท่านจะต้องทำการยืนยันตัวตนอิเล็กทรอนิกส์ (eKYC) อีกครั้ง หลังจากส่งใบคำขอเข้าระบบ AdvisorZone`}
      </span>
    </div>
  )
}

function IdentifyEkycRespondingModal({
  identifyEkycRespond,
  insuredOrPayer,
  isOpen,
  onExit,
  isDuplicate,
  isReuseCase,
  onSubmit,
  isReuseCaseSelected,
  isRemoteSellingRespond,
  selectedRemoteSelling,
}) {
  const dispatch = useDispatch()
  const [isSkipEkyc, setIsSkipEkyc] = useState(false)

  const app = useSelector(getCurrentApp)
  const isOnDeviceEkyc = isOnDeviceEKYC(app)
  const isDisable2ndDoc = shouldDisable2ndDoc()

  const toggleSkippingEKYC = useCallback((forceToFalse) => {
    setIsSkipEkyc((prevState) => {
      return typeof forceToFalse === 'boolean' ? forceToFalse : !prevState
    })
  }, [])

  const handleRemoveError = useCallback(() => {
    dispatch(removeError('EKYC_VERIFY_CITIZENID'))
    dispatch(removeError('EKYC_REUSE_CASE'))
  }, [dispatch])

  const handleSetSkippedEkyc = useCallback(() => {
    dispatch(setAppValue(`ekycInfo.${insuredOrPayer}.skipped`, true))
  }, [dispatch, insuredOrPayer])

  const onExitWithRollbackSkippingEkycState = useCallback(() => {
    toggleSkippingEKYC(false)
    handleRemoveError()
    onExit()
  }, [toggleSkippingEKYC, handleRemoveError, onExit])

  if (!selectedRemoteSelling && (isDuplicate || isReuseCaseSelected)) {
    onExit()
    return null
  }

  const isInvalidCase = identifyEkycRespond === 'failed' || identifyEkycRespond === 'failedReuse'
  const resourceWithStateResponse =
    isReuseCase && identifyEkycRespond === 'success' ? resource['reuseSuccess'] : resource[identifyEkycRespond]

  if (!resourceWithStateResponse) {
    return null
  }

  return (
    <Modal
      className={'identify-ekyc-responding-modal'}
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
    >
      <ModalHeader
        className={'header-modal'}
        toggle={() => {
          onExitWithRollbackSkippingEkycState()
        }}
      />
      <ModalBody>
        <div className={`normal-text ${identifyEkycRespond}`}>{resourceWithStateResponse.icon}</div>
        <h5 className={'text-header normal-text'}>
          {resourceWithStateResponse.titleText(isOnDeviceEkyc, isDisable2ndDoc, isRemoteSellingRespond)}
        </h5>
        <div
          dangerouslySetInnerHTML={{
            __html: resourceWithStateResponse.detailText(isOnDeviceEkyc, isDisable2ndDoc, isRemoteSellingRespond),
          }}
          className={'normal-text detail-text'}
        />
        {isInvalidCase && !isRemoteSellingRespond && (
          <AdditionalForFailedCase
            toggleSkippingEKYC={toggleSkippingEKYC}
            isSkipEkyc={isSkipEkyc}
            isDisable2ndDoc={isDisable2ndDoc}
            identifyEkycRespond={identifyEkycRespond}
          />
        )}
        <SubmitButton
          onExit={onExitWithRollbackSkippingEkycState}
          removeError={handleRemoveError}
          isInvalid={isInvalidCase}
          isSkipEkyc={isSkipEkyc || isRemoteSellingRespond}
          setSkippedEkyc={handleSetSkippedEkyc}
          isRemoteSellingRespond={isRemoteSellingRespond}
          onSubmit={onSubmit}
        />
      </ModalBody>
    </Modal>
  )
}

export default IdentifyEkycRespondingModal
